import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import base64 from 'base64-arraybuffer';
import sha256 from './sha-256';
import { stringToArrayBuffer } from './utils';
var HKDF_ALGORITHM_NAME = 'HKDF';
var RAW_KEY_TYPE = 'raw';
var KEY_IS_NOT_EXTRACTABLE = false;
var KEY_WILL_BE_USED_TO = ['deriveKey', 'deriveBits'];

var importHkdfKeyFromString = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(seedString) {
    var seed, hkdfKey;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            seed = stringToArrayBuffer(seedString);
            _context.next = 3;
            return importHkdfKey(seed);

          case 3:
            hkdfKey = _context.sent;
            return _context.abrupt("return", hkdfKey);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function importHkdfKeyFromString(_x) {
    return _ref.apply(this, arguments);
  };
}();

var importHkdfKey = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(seed) {
    var hkdfKey;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return window.crypto.subtle.importKey(RAW_KEY_TYPE, seed, {
              name: HKDF_ALGORITHM_NAME
            }, KEY_IS_NOT_EXTRACTABLE, KEY_WILL_BE_USED_TO);

          case 2:
            hkdfKey = _context2.sent;
            return _context2.abrupt("return", hkdfKey);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function importHkdfKey(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 *  RFC 5869:
 *
 *  "the use of salt adds significantly to the strength of HKDF...
 *  Ideally, the salt value is a random (or pseudorandom) string of the
 *  length HashLen"
 *
 *  https://tools.ietf.org/html/rfc5869#section-3.1
 *
 **/


var SALT_BYTE_SIZE = sha256.BYTE_SIZE;

var generateSalt = function generateSalt() {
  return window.crypto.getRandomValues(new Uint8Array(SALT_BYTE_SIZE));
};

var getParams = function getParams(keyName, salt) {
  return {
    name: HKDF_ALGORITHM_NAME,
    info: stringToArrayBuffer(keyName),
    hash: sha256.HASH_ALGORITHM_NAME,
    salt: salt
  };
};

var PASSWORD_TOKEN_NAME = 'password-token';
var PASSWORD_TOKEN_NUM_BITS = 256;

var getPasswordToken = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(hkdfKey, salt) {
    var passwordTokenBits;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return window.crypto.subtle.deriveBits(getParams(PASSWORD_TOKEN_NAME, salt), hkdfKey, PASSWORD_TOKEN_NUM_BITS);

          case 2:
            passwordTokenBits = _context3.sent;
            return _context3.abrupt("return", base64.encode(passwordTokenBits));

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getPasswordToken(_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();

export default {
  importHkdfKeyFromString: importHkdfKeyFromString,
  importHkdfKey: importHkdfKey,
  generateSalt: generateSalt,
  getParams: getParams,
  getPasswordToken: getPasswordToken
};